import { Skeleton } from '@/components/Skeleton';
import { SKELETON_COLOR_SCHEMES } from '@/components/Skeleton/constants';

export const StepSkeleton = () => <Skeleton width="60%" {...SKELETON_COLOR_SCHEMES['gray-216-gray-100']} />;
